export const GET_DESTINATION = 'GET_DESTINATION';
export const SET_DESTINATION = 'SET_DESTINATION';
